import React from 'react'

interface SearchOverlayProps {
  onClick: () => void
}

export const SearchOverlay: React.FC<SearchOverlayProps> = ({ onClick }) => {
  return <div onClick={onClick} className="dxp-search-backdrop fade show"></div>
}
